import { styled, alpha, Box, Table, Grid } from '@mui/material';
import { CollapseCard } from '@totalsoft/rocket-ui';

export const AllowedFormulaVariablesCollapsedCard = styled(CollapseCard)(({ theme }) => ({
  '& .MuiCardHeader-root': {
    paddingBlock: theme.spacing(1.5),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1.5),
    backgroundColor: alpha(theme.palette.primary.main, 0.05)
  },
  '& .MuiCardHeader-action .MuiButton-root': {
    width: '30px',
    height: '30px'
  },
  '& .MuiCardContent-root': {
    paddingInline: theme.spacing(2)
  }
}));

export const AllowedFormulaVariablesTableContainer = styled(Box)(({ theme }) => ({
  maxHeight: '230px',
  overflowY: 'auto',
  paddingRight: theme.spacing(1)
}));

export const AllowedFormulaVariablesTable = styled(Table)(({ theme }) => ({
  tableLayout: 'fixed',
  '& .MuiTableCell-root': {
    fontSize: '14px',
    paddingBlock: theme.spacing(1),
    paddingInline: theme.spacing(1.5)
  }
}));

export const AllowedFormulaVariablesTableHeadContainer = styled(Grid)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.primary.main, 0.05),
  borderRadius: theme.spacing(1)
}));
